export { default } from './ConfirmationCodeFormModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeFormModal/index.js